import { Form } from "react-bootstrap";
import './Label.css';

export default function Label({ label, style, htmlFor }) {
    return (
        <>
            <Form.Label style={style} htmlFor={htmlFor}>{label}</Form.Label>
        </>
    )
}